(() => {
  'use strict';
  if (window.rrCollectionEditorial) return;
  window.rrCollectionEditorial = true;
  const roots = new WeakSet();
  const mobile = matchMedia('(max-width: 749px)');
  let scheduled = false;

  function updateHeaderOffset() {
    scheduled = false;
    const headers = document.querySelectorAll('.o-header-group, .o-header, .shopify-section-group-header-group');
    let bottom = 0;
    headers.forEach(header => {
      const style = getComputedStyle(header);
      if (style.position !== 'sticky' && style.position !== 'fixed') return;
      const rect = header.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
    });
    document.querySelectorAll('.rr-collection').forEach(root => root.style.setProperty('--rr-sticky-header', `${Math.round(bottom)}px`));
  }
  function scheduleOffset() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updateHeaderOffset); }
  }
  function refresh(root) {
    root.querySelectorAll('[data-rr-view]').forEach(button => {
      const current = button.dataset.device === 'mobile' ? root.dataset.viewMobile : root.dataset.viewDesktop;
      button.setAttribute('aria-pressed', String(current === button.dataset.rrView));
    });
    const count = root.querySelector('[data-rr-filter-count]');
    if (count) {
      const params = new URLSearchParams(location.search);
      const active = [...params.entries()].filter(([key, value]) => key.startsWith('filter.') && value !== '').length;
      count.textContent = active ? `(${active})` : '';
    }
    const columns = mobile.matches ? root.dataset.viewMobile : root.dataset.viewDesktop;
    root.querySelectorAll('.rr-plp-card__photo, .m-collection-promotion__image').forEach(image => {
      image.sizes = `${100 / Number(columns)}vw`;
    });
    root.querySelectorAll('.rr-plp-filters .m-sort__options').forEach(menu => menu.setAttribute('aria-label', 'Sort by'));
  }
  function init() {
    document.querySelectorAll('.rr-collection').forEach(root => {
      if (!roots.has(root)) {
        roots.add(root);
        for (const device of ['desktop', 'mobile']) {
          const allowed = device === 'desktop' ? ['1', '4', '6', '12'] : ['1', '2', '4'];
          try {
            const saved = sessionStorage.getItem(`rr-plp-${device}`);
            if (allowed.includes(saved)) root.dataset[device === 'desktop' ? 'viewDesktop' : 'viewMobile'] = saved;
          } catch (_) { /* Private browsing can disable storage. */ }
        }
        const container = root.querySelector('.js-product-grid-container');
        if (container) new MutationObserver(records => {
          if (records.some(record => record.target === container)) refresh(root);
          records.forEach(record => {
            if (!record.target.matches?.('.m-product-card__price')) return;
            const dialogPrice = record.target.closest('.rr-plp-card')?.querySelector('.rr-plp-product__price');
            if (dialogPrice) dialogPrice.innerHTML = record.target.innerHTML;
          });
          if (!document.querySelector('.rr-plp-dialog[open]')) document.body.classList.remove('rr-plp-modal-open');
        }).observe(container, { childList: true, subtree: true });
      }
      refresh(root);
    });
    scheduleOffset();
  }
  function close(dialog) {
    dialog.close();
    document.body.classList.toggle('rr-plp-modal-open', !!document.querySelector('.rr-plp-dialog[open]'));
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const view = target.closest('[data-rr-view]');
    if (view) {
      const root = view.closest('.rr-collection');
      if (!root) return;
      root.dataset[view.dataset.device === 'mobile' ? 'viewMobile' : 'viewDesktop'] = view.dataset.rrView;
      try { sessionStorage.setItem(`rr-plp-${view.dataset.device}`, view.dataset.rrView); } catch (_) {}
      refresh(root);
      return;
    }
    const opener = target.closest('[data-rr-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.rrOpen);
      if (!dialog) return;
      event.preventDefault();
      if (window.WhatSub) window.WhatSub.dispatch('UPDATE_FILTERS', true);
      dialog.showModal();
      document.body.classList.add('rr-plp-modal-open');
      if (dialog.classList.contains('rr-plp-product')) {
        if (opener.dataset.size) {
          const field = [...dialog.querySelectorAll('.m-variants__fieldset')].find(item => item.dataset.option === opener.dataset.option);
          const input = field && [...field.querySelectorAll('input')].find(item => item.value === opener.dataset.size);
          if (input && !input.disabled) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      }
      return;
    }
    const closer = target.closest('[data-rr-close]');
    if (closer) { close(closer.closest('dialog')); return; }
    if (target.matches('.rr-plp-dialog[open]')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(target);
    }
    const swatch = target.closest('.rr-plp-card .m-product-card__swatch');
    if (swatch) {
      const card = swatch.closest('.rr-plp-card');
      card.querySelectorAll('.m-product-card__swatch').forEach(item => {
        item.classList.toggle('is-selected', item === swatch);
        item.setAttribute('aria-pressed', String(item === swatch));
      });
      const label = card.querySelector('[data-rr-color-label]');
      if (label) label.textContent = swatch.title;
      // Keep the displayed color and the Quick Add selection consistent.
      const field = [...card.querySelectorAll('.m-variants__fieldset')].find(item => /colou?r/.test(item.dataset.option));
      const input = field && [...field.querySelectorAll('input')].find(item => item.value.split(/\s*-\s*ETA\b/i)[0].trim() === swatch.title);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('.rr-plp-dialog')) {
      event.target.querySelector('.js-quick-add-variants')?.classList.remove('m-quick-add-variants--open');
      document.body.classList.toggle('rr-plp-modal-open', !!document.querySelector('.rr-plp-dialog[open]'));
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const swatch = event.target.closest('.rr-plp-card .m-product-card__swatch:not([data-variant-image])');
    if (swatch) { event.preventDefault(); swatch.click(); }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.rr-plp-product .m-variants__input')) return;
    const field = event.target.closest('.m-variants__fieldset');
    if (!/colou?r/.test(field.dataset.option)) return;
    const label = field.closest('.rr-plp-card').querySelector('[data-rr-color-label]');
    if (label) label.textContent = event.target.value.split(/\s*-\s*ETA\b/i)[0].trim();
  });
  addEventListener('scroll', scheduleOffset, { passive: true });
  addEventListener('resize', () => { init(); });
  addEventListener('popstate', () => { document.querySelectorAll('.rr-collection').forEach(refresh); });
  addEventListener('shopify:section:load', init);
  addEventListener('load', () => {
    init();
    if (window.WhatSub) {
      window.WhatSub.subscribe('UPDATE_FILTERS', () => { document.querySelectorAll('.rr-collection').forEach(refresh); });
      window.WhatSub.subscribe('PRODUCT_FORM_ADD_TO_CART', () => {
        document.querySelectorAll('.rr-plp-product[open]').forEach(close);
      });
    }
  });
  init();
})();
